<template>
  <div>
    <iMineTemplate
      :page-title="pageTitle"
      :actived-parent-key="activedParentKey"
      :actived-key="activedKey"
    >
      <template #rightContent>
        <div v-if="OrderId && dataInfo" class="order-details-box">
          <div class="orderStatus pl20 pt20 pr20 mb20">
            <div class="title text-left pb20 border-b">
              <span class="c222 f16">订单编号：{{ dataInfo.OrderNo }}</span>
            </div>
            <div
              class="content flex"
              :style="{
                justifyContent: orderStepActive <= 0 ? 'center' : 'flex-start'
              }"
            >
              <div class="leftbtn" :class="{ 'border-r': orderStepActive > 0 }">
                <div class="mt40 pr10">
                  <van-image
                    :src="
                      statusList.filter((t) => t.name == dataInfo.statusName)[0]
                        .icon
                    "
                    width="50px"
                  />
                  <div
                    class="f24 fw600 mt10"
                    :class="
                      statusList.filter((t) => t.name == dataInfo.statusName)[0]
                        .class
                    "
                  >
                    {{
                      statusList.filter((t) => t.name == dataInfo.statusName)[0]
                        .title
                    }}
                  </div>
                  <div
                    v-if="
                      (!dataInfo.TotalAmountPaid ||
                        dataInfo.TotalAmountPaid == 0) &&
                        dataInfo.statusName == '待付款' &&
                        dataInfo.OffTime &&
                        dataInfo.OffTime > 0
                    "
                    class="f14 c999"
                  >
                    剩余{{
                      parseInt((dataInfo.OffTime || 0) / 60) > 0
                        ? `${parseInt((dataInfo.OffTime || 0) / 60)}时`
                        : ''
                    }}{{ parseInt((dataInfo.OffTime || 0) % 60) }}分
                  </div>
                </div>
                <div class="btns mt30 pl10 pr10 pb30">
                  <van-button
                    v-if="
                      dataInfo.statusName == '待付款' &&
                        !dataInfo.TotalAmountPaid &&
                        dataInfo.OrderPaymentState != 7 &&
                        dataInfo.IsOnlineApplyBack
                    "
                    type="default"
                    class="bFF3939"
                    @click.stop="() => onPay(dataInfo)"
                  >
                    立即付款
                  </van-button>
                  <van-button
                    v-if="
                      dataInfo.statusName == '待付款' &&
                        !dataInfo.IsOnlineApplyBack
                    "
                    type="default"
                    class="refundBtn"
                  >
                    {{ dataInfo.IsOnlineApplyBack ? '' : '退款中' }}
                  </van-button>
                  <van-button
                    v-if="
                      dataInfo.statusName == '待付款' &&
                        dataInfo.TotalAmountPaid &&
                        dataInfo.OrderPaymentState != 7 &&
                        dataInfo.IsOnlineApplyBack
                    "
                    type="default"
                    class="bFF3939"
                    @click.stop="() => onPay(dataInfo)"
                  >
                    继续支付
                  </van-button>
                  <van-button
                    v-if="
                      dataInfo.statusName != '待付款' &&
                        dataInfo.statusName != '待发货' &&
                        IsOrder
                    "
                    type="default"
                    class="bFF3939"
                    :disabled="submitingRepurchase"
                    @click.stop="() => handleRepurchase(dataInfo)"
                  >
                    再次购买
                  </van-button>
                  <van-button
                    v-if="
                      dataInfo.statusName == '待发货' && dataInfo.OnlineIsBack
                    "
                    size="mini"
                    class="ml20 plainBtnBlack"
                    :disabled="isRefund"
                    @click.stop="handleApplyRefund(dataInfo)"
                  >申请退款
                  </van-button>
                  <van-button
                    v-if="
                      dataInfo.statusName == '待付款' &&
                        dataInfo.IsOnlineApplyBack
                    "
                    type="default"
                    class="bE5E5E5"
                    @click.stop="() => cancelOrder(dataInfo)"
                  >
                    取消订单
                  </van-button>
                  <!-- <van-button type="default" class="bE5E5E5">申请退款</van-button> -->
                  <van-button
                    v-if="dataInfo.statusName == '已发货'"
                    type="default"
                    class="b0F6EE9"
                    @click.stop="() => handleConfirmGoods(dataInfo)"
                  >
                    确认收货
                  </van-button>

                  <van-button
                    v-if="
                      dataInfo.statusName != '待付款' &&
                        dataInfo.statusName != '已关闭' &&
                        !dataInfo.IsHasOrderInvoice
                    "
                    type="default"
                    class="bE5E5E5"
                    @click.stop="() => goApplyInvoice(dataInfo)"
                  >
                    申请开票
                  </van-button>
                  <van-button
                    v-if="
                      dataInfo.statusName != '待付款' &&
                        dataInfo.IsHasOrderInvoice
                    "
                    type="default"
                    class="bE5E5E5"
                    @click.stop="showInvoice(dataInfo.Id)"
                  >
                    查看发票
                  </van-button>
                </div>
              </div>
              <div v-if="orderStepActive > 0" class="rightimg">
                <!-- <van-steps :active="orderStepActive" active-color="#2B84F6" active-icon inactive-icon>
                                  <van-step v-for="(v,i) in orderSteps" :key="i">
                                    <van-icon :name="v.icon" size="34" />
                                    <div>
                                      <h3 class="f14" :class="orderStepActive >= i?'c222':'c777'">{{v.title}}</h3>
                                      <p class="f12 c777">&nbsp;{{v.time}}</p>
                                    </div>
                                  </van-step>
                                </van-steps> -->
                <img
                  style="height: 87px;"
                  :src="require(`@/assets/order/st${orderStepActive}.png`)"
                >
              </div>
            </div>
          </div>

          <!-- 物流信息 -->
          <div
            v-if="
              (dataInfo.statusName == '已发货' ||
                dataInfo.statusName == '已收货') &&
                logisticsData &&
                logisticsData.length > 0
            "
            class="pl20 pt20 pr20 border mb20 bgfff i_radius pb40 logistics-box"
          >
            <div class="title text-left pb20 border-b">
              <span class="c222 f16">物流信息</span>
            </div>
            <!-- 1.5.5新物流模块 -->
            <div class="flex-box">
              <div v-if="logisticsData.length > 1" class="flex-box-menu">
                <a-radio-group
                  v-for="(item, index) in logisticsData"
                  :key="index"
                  v-model="changeVal"
                  @change="onChangeLogistics"
                >
                  <a-radio
                    :value="item.LogisticsWaybillNo"
                  >包裹{{ index + 1 }}</a-radio>
                </a-radio-group>
              </div>
              <div class="flex-box-cont">
                <van-steps
                  direction="vertical"
                  :active="0"
                  class="text-left pl30"
                  active-color="#222222"
                >
                  <van-step
                    v-for="(item, index) in changeData"
                    :key="index"
                    style="padding: 12px 0;"
                  >
                    <!-- <div class="c777 f14 fw500 pl20">{{ item.Title ? item.Title : dataInfo.stateName }}</div> -->
                    <div class="c777 f12 pl20 mb5">{{ item.Note }}</div>
                    <div class="c222 f12 pl20">{{ item.Time }}</div>
                    <template #active-icon>
                      <van-icon
                        :name="require('@/assets/order/yunshuzhong-icon.png')"
                        size="26px"
                      />
                    </template>
                    <template #inactive-icon>
                      <van-icon
                        v-if="changeData.length - 1 == index"
                        :name="require('@/assets/order/yunshu-n-icon.png')"
                        size="26px"
                      />
                    </template>
                  </van-step>
                </van-steps>
              </div>
              <!-- <div class="flex-box-cont" v-if="logistics.LogisticsDocmentTrail && logistics.LogisticsDocmentTrail.length">
								<van-steps direction="vertical" :active="0" class="text-left pl30" active-color="#222222">
									<van-step v-for="(item, index) in logistics.LogisticsDocmentTrail" :key="index" class="p0 pb20">
										<div class="c777 f14 fw500 pl20">{{ item.Title ? item.Title : dataInfo.stateName }}</div>
										<div class="c777 f14 pl20 mb5">{{ item.Note }}</div>
										<div class="c222 f12 pl20">{{ item.Time }}</div>
										<template #active-icon>
											<van-icon :name="require('@/assets/order/yunshuzhong-icon.png')" size="26px" />
										</template>
										<template #inactive-icon>
											<van-icon :name="require('@/assets/order/yunshu-n-icon.png')" size="26px" v-if="logistics.LogisticsDocmentTrail.length - 1 == index" />
										</template>
									</van-step>
								</van-steps>
							</div> -->
            </div>
          </div>

          <div v-if="dataInfo.DiscountAmount != 0" class="customer-title">
            <!--                <span>您在2021年1月23日-2021年3月21日期间下单(不限订单金额)可享受9.5折优惠</span>-->
            <span>{{ dataInfo.OrderDiscountDescription }}</span>
            <span
              style="color: red;"
            >订单已优惠金额：{{ dataInfo.DiscountAmount * -1 }}元</span>
          </div>

          <!-- 收货信息 -->
          <div class="pl20 pt20 pr20 border mb20 bgfff i_radius pb40">
            <div class="title text-left pb20 border-b">
              <span class="c222 f16">收货信息</span>
            </div>
            <van-cell
              title="收货人"
              :border="false"
              title-class="f14 c777 flex-n w86 text-left"
              :value="dataInfo.ReceivingMan"
              value-class="c222 f14 text-left pl20"
              class="pt20 pb0 pl0 pr0"
            />
            <van-cell
              title="联系方式"
              :border="false"
              title-class="f14 c777 flex-n w86 text-left"
              :value="dataInfo.ReceivingManTel"
              value-class="c222 f14 text-left pl20"
              class="pt20 pb0 pl0 pr0"
            />
            <van-cell
              title="收货地址"
              :border="false"
              title-class="f14 c777 flex-n w86 text-left"
              :value="`${dataInfo.ReceivingAreaFullName} ${dataInfo.ReceivingAddress}`"
              value-class="c222 f14 text-left pl20"
              class="pt20 pb0 pl0 pr0"
            />
          </div>
          <!-- 商品信息 -->
          <!-- <div class="pl20 pt20 pr20 border mb20 bgfff i_radius pb40">
            <div class="title text-left pb20 border-b">
              <span class="c222 f16">商品信息</span>
            </div>

          </div> -->
          <!-- 商品信息 -->
          <div class="card pl20 pt20 pr20 border mb20 bgfff i_radius pb40">
            <div class="card-t">
              商品信息
              <span style="margin-left: 350px;">单价</span>
              <span style="margin-left: 94px;">数量</span>
              <span style="margin-left: 92px;">小计</span>
              <span style="margin-left: 92px;">实付</span>
            </div>
            <div class="card-i" style="padding: 0;">
              <div
                v-for="(goods, key) in GoodsList"
                :key="key+'a'"
              >
                <ProductDetails :goods="goods" :type="goods.ActivityCode" :gift-type="0" />
              </div>
              <!-- 换购 -->
              <div
                v-for="(goods,key) in ExchangeList"
                :key="key+'b'"
              >
                <ProductDetails :goods="goods" :gift-type="2" />
              </div>
              <!-- 赠品 -->
              <div
                v-for="(goods,key) in GiftList"
                :key="key+'c'"
              >
                <ProductDetails :goods="goods" :gift-type="1" />
              </div>
            </div>
          </div>
          <!-- 订单信息 -->
          <div class="pl20 pt20 pr20 border mb20 bgfff i_radius">
            <van-cell
              :border="false"
              class="border-b pb20 pt0 pl0 pr0"
              title="订单信息"
              title-class="f14 c222 text-left"
              :value="
                dataPayInfo &&
                  dataPayInfo.filter((t) => t.EnumExpenseApplicationState == 2)
                    .length &&
                  dataInfo.statusName != '已关闭'
                  ? '支付信息'
                  : ''
              "
              value-class="f14 c222 text-left"
            />
            <van-row>
              <van-col :span="12" class="pb20">
                <van-cell
                  title="订单编号"
                  :border="false"
                  title-class="f14 c777 flex-n w86 text-left"
                  :value="dataInfo.OrderNo"
                  value-class="c222 f14 text-left pl20"
                  class="pt20 pb0 pl0 pr0"
                />
                <van-cell
                  title="下单时间"
                  :border="false"
                  title-class="f14 c777 flex-n w86 text-left"
                  :value="dataInfo.CreateTime"
                  value-class="c222 f14 text-left pl20"
                  class="pt10 pb20 pl0 pr0"
                />
              </van-col>
              <van-col
                :span="12"
                class="pl20 pb20"
                :class="{
                  'border-l':
                    dataPayInfo &&
                    dataPayInfo.filter(
                      (t) => t.EnumExpenseApplicationState == 2
                    ).length &&
                    dataInfo.statusName != '已关闭'
                }"
              >
                <div
                  v-if="
                    dataPayInfo &&
                      dataPayInfo.filter(
                        (t) => t.EnumExpenseApplicationState == 2
                      ).length &&
                      dataInfo.statusName != '已关闭'
                  "
                >
                  <van-cell-group
                    v-for="(item, index) in dataPayInfo.filter(
                      (t) => t.EnumExpenseApplicationState == 2
                    )"
                    :key="index"
                    :border="false"
                  >
                    <van-cell
                      :border="false"
                      title-class="f14 c777 flex-n text-left w120"
                      :value="item.PayType"
                      value-class="c222 f14 text-left pl20"
                      class="pt20 pb0 pl0 pr0"
                    >
                      <template #title>
                        <div>
                          <van-tag
                            v-if="
                              dataPayInfo.filter(
                                (t) => t.EnumExpenseApplicationState == 2
                              ).length > 1
                            "
                            color="#E5F0FF"
                            class="c0F6EEA f10 mr10 lhn"
                          >
                            {{ index < 9 ? '0' + (index + 1) : index + 1 }}
                          </van-tag>
                          支付方式
                        </div>
                      </template>
                    </van-cell>
                    <van-cell
                      title="支付金额"
                      :border="false"
                      :title-class="
                        dataPayInfo.filter(
                          (t) => t.EnumExpenseApplicationState == 2
                        ).length > 1
                          ? 'f14 c777 flex-n text-left tindent36 w120'
                          : 'f14 c777 flex-n text-left w120'
                      "
                      :value="`￥${item.AmountTotal.toFixed(2)}`"
                      value-class="c222 f14 text-left pl20"
                      class="pt20 pb0 pl0 pr0"
                    />
                    <van-cell
                      title="支付时间"
                      :border="false"
                      :title-class="
                        dataPayInfo.filter(
                          (t) => t.EnumExpenseApplicationState == 2
                        ).length > 1
                          ? 'f14 c777 flex-n text-left tindent36 w120'
                          : 'f14 c777 flex-n text-left w120'
                      "
                      :value="item.PayTime"
                      value-class="c222 f14 text-left pl20"
                      class="pt20 pb0 pl0 pr0"
                    />
                    <van-cell
                      title="交易流水号"
                      :border="false"
                      :title-class="
                        dataPayInfo.filter(
                          (t) => t.EnumExpenseApplicationState == 2
                        ).length > 1
                          ? 'f14 c777 flex-n text-left tindent36 w120'
                          : 'f14 c777 flex-n text-left w120'
                      "
                      :value="item.ExpenseApplicationNo"
                      value-class="c222 f14 text-left pl20"
                      class="pt20 pb20 pl0 pr0"
                      :class="{
                        'border-b':
                          dataPayInfo.filter(
                            (t) => t.EnumExpenseApplicationState == 2
                          ).length -
                          1 !=
                          index
                      }"
                    />
                  </van-cell-group>
                </div>
              </van-col>
            </van-row>
          </div>
          <!--  -->
          <div class="pl20 pt20 pr20 border mb20 bgfff i_radius">
            <van-cell-group :border="false">
              <!-- <van-cell
                title="商品盒数："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`${getProductsCount()}盒`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt0 pb0 pl0 pr0"
              /> -->
              <van-cell
                title="商品金额："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`￥${Number(dataInfo.CommodityAmountSum).toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />
              <van-cell
                v-if="dataInfo.ExchangeAmount"
                title="换购金额："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`￥${Number(dataInfo.ExchangeAmount).toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />
              <van-cell
                v-if="dataInfo.FreebiesAmountSum"
                title="赠品金额："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`￥${Number(dataInfo.FreebiesAmountSum).toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />
              <van-cell
                v-if="dataInfo.ActivityAmount"
                title="活动优惠："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`- ￥${Math.abs(dataInfo.ActivityAmount).toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />
              <van-cell
                v-if="dataInfo.ExchangeDiscountAmount"
                title="换购优惠："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`- ￥${Math.abs(dataInfo.ExchangeDiscountAmount).toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />
              <van-cell
                v-if="dataInfo.ExchangeDiscountAmount"
                title="赠品优惠："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`- ￥${Math.abs(dataInfo.FullGifteDiscounAmount).toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />
              <van-cell
                v-if="dataInfo.TicketAmount"
                title="优惠券："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`-￥${Math.abs(dataInfo.TicketAmount.toFixed(2))}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />
              <van-cell
                v-if="dataInfo.CustomerDiscounAmount"
                :border="false"
                center
                title="客户折扣"
                :value="`-￥${Math.abs(dataInfo.CustomerDiscounAmount.toFixed(2))}`"
                title-class="f16 c777 text-right"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0 pt30i pb0i"
              >
                <template #title>
                  <div style=" position: relative;">
                    客户折扣:
                    <van-tag
                      v-if="dataInfo.CustomerDiscounRate > 0"
                      color="#FF3939"
                      plain
                      class=" is-sys-choose-tips"
                    >享{{ dataInfo.CustomerDiscounRate }}折
                    </van-tag>
                  </div>
                </template>
              </van-cell>
              <van-cell
                v-if="dataInfo.TotalAmountDiscount"
                title="总优惠金额："
                :border="false"
                title-class="f16 c777 text-right "
                :value="`-￥${Number(dataInfo.TotalAmountDiscount).toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />

              <van-cell
                :title="
                  dataInfo.PayLogisticsAmount == 0 ? '运费(包邮)：' : '运费：'
                "
                :border="false"
                title-class="f16 c777 text-right "
                :value="`￥${dataInfo.PayLogisticsAmount.toFixed(2)}`"
                value-class="cFF3939 f16 fw600 text-right flex-n w208"
                class="pt20 pb0 pl0 pr0"
              />

              <van-cell
                title="实付金额："
                :border="false"
                title-class="f16 c222 text-right fw600"
                :value="`￥${Number(dataInfo.TotalAmountPaidActual).toFixed(
                  2
                )}`"
                value-class="cFF3939 f26 fw600 text-right flex-n w208"
                class="pt20 pb40 pl0 pr0"
              />
            </van-cell-group>
          </div>
        </div>
      </template>
    </iMineTemplate>
    <!-- 对话框 -->
    <iDialog
      ref="iDialogref"
      :msg="dialogMsg"
      confirm-btn-text="确认"
      cancel-btn-text="取消"
      :width="dialogMsg == '申请退款' ? '500px' : '560px'"
      @confirm="confirmDialog"
    >
      <template #bottom>
        <div v-if="dialogMsg == '申请退款'">
          <div class="f16 c222 text-left" style="padding: 0 100px;">
            可退款金额：
            <span
              class="f16 cFF3939 fw600 ml5"
            >¥ {{ dataInfo.TotalAmountPaid }}</span>
          </div>
          <div style="padding: 15px 100px 30px;">
            <van-notice-bar
              wrapable
              :scrollable="false"
              color="#D3691F"
              background="#FFF6D8"
              class="cBABABA pl15 pr15 text-left f14 mt10"
            >
              <van-icon
                :name="require('@/assets/mine/note.png')"
                size="20px"
                class="mr5"
                style="position: relative; top: 5px;"
              />
              注：申请退款后，平台将在1-2个工作日审核。退款金额将原路退回至您付款账户中。
            </van-notice-bar>
          </div>
        </div>
      </template>
    </iDialog>
    <!-- 申请开票弹框 -->
    <van-overlay
      :show="iApplyInvoice"
      z-index="5"
      @click="iApplyInvoice = false"
    >
      <div class="wrapper" @click.stop>
        <ApplyInvoiceForm
          ref="iApplyInvoice"
          isdialog
          :sum-data="dataInfo"
          @cancel="handleCancelInvoice"
          @confirm="handleConfirmInvoice"
        />
      </div>
    </van-overlay>
    <!-- 线上退款二次确认 -->
    <el-dialog
      title="申请退款"
      :visible.sync="dialogVisible"
      custom-class="apply-wrap-box"
      width="500px"
      :before-close="handleClose"
    >
      <h6>是否确认退款？</h6>
      <p>（确认退款后，退款金额将原路返回）</p>
      <span slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button
          style="margin-right: 70px; width: 140px;"
          @click="dialogVisible = false"
        >取 消</el-button>
        <el-button
          type="primary"
          style="width: 140px;"
          @click="handleOnlineRefund"
        >确 定</el-button>
      </span>
    </el-dialog>
    <LookInvoiceInfo
      ref="lookinvoiceinfo"
      :order-state="
        dataInfo &&
          statusList.filter((t) => t.name == dataInfo.statusName)[0].title
      "
    />
    <CancelOrder ref="cancelorder" @againLoad="againLoad" />
  </div>
</template>
<script>
import { LinkTypeCode } from '@/dictionary/base.js'
import { BaseMixin } from '../../mixins/BaseMixin.js'
import LookInvoiceInfo from './LookInvoiceInfo.vue'
import CancelOrder from './CancelOrder.vue'
import ProductDetails from './components/ProductDetails'
export default {
  name: 'OrderDetails',
  components: {
    LookInvoiceInfo,
    ProductDetails,
    CancelOrder
  },
  mixins: [BaseMixin],
  data() {
    return {
      pageTitle: ['我的账户', '我的订单'],
      activedParentKey: 2,
      activedKey: 21,
      loading: true,
      dataInfo: null,
      dataPayInfo: [],
      logistics: null,
      submitingRepurchase: false,
      bankInfo: {},
      showBank: false,
      IsOrder: false,
      OrderId: null,
      orderStepActive: 1,
      isRefund: false,
      dialogVisible: false,
      orderSteps: [
        {
          icon: require('@/assets/order/step1.png'),
          title: '提交订单',
          time: '2020-04-26 10:09:07'
        },
        {
          icon: require('@/assets/order/step2.png'),
          title: '付款成功',
          time: '2020-04-26 10:09:07'
        },
        {
          icon: require('@/assets/order/step3.png'),
          title: '等待收货',
          time: ''
        },
        {
          icon: require('@/assets/order/step4.png'),
          title: '交易完成',
          time: ''
        }
      ],
      shopTabTh: ['商品信息', '单价', '最低零售价', '数量', '小计', '实付'],
      statusList: [
        {
          name: '待付款',
          icon: require('@/assets/order/daifukuan-icon.png'),
          title: '等待付款',
          class: 'cFF3939'
        },
        {
          name: '待发货',
          icon: require('@/assets/order/daifahuo-icon.png'),
          title: '等待发货',
          class: 'c0F6EE9'
        },
        {
          name: '已关闭',
          icon: require('@/assets/order/guanbi-icon.png'),
          title: '交易关闭',
          class: 'c777'
        },
        {
          name: '已发货',
          icon: require('@/assets/order/daishouhuo-icon.png'),
          title: '等待收货',
          class: 'c0F6EE9'
        },
        {
          name: '已收货',
          icon: require('@/assets/order/wancheng-icon.png'),
          title: '交易完成',
          class: 'c0F6EE9'
        }
      ],
      iApplyInvoice: false,
      dialogMsg: '',
      // 物流包裹切换参数
      changeVal: '',
      logisticsData: [],
      changeData: [],

      GoodsList: [],
      ExchangeList: [],
      GiftList: []

    }
  },
  created() {
    const orderId = this.$route.query.orderId
      ? this.$route.query.orderId
      : this.$route.query.id
        ? this.$route.query.id
        : ''
    this.OrderId = orderId
  },
  mounted() {
    this.IsOrder = this.$auth.getCustomerOtherInfo().IsOrder
    this.getOrderDetails()
    this.getOrderLists()
    this.getOrderPayDetails()
  },
  methods: {
    refundStatusChange(i) {
      let status = ''
      switch (i) {
        case 1:
          status = '退款中'
          break
        case 2:
          status = '退款成功'
          break
        case 3:
          status = '退款失败'
          break
        case 4:
          status = '退款关闭'
          break
        default:
          break
      }
      return status
    },
    handleClose() {
      this.dialogVisible = false
    },
    // 申请退款
    handleApplyRefund(item) {
      // 检查是否可以退款
      this.getAction('/api_aftersale/AfterSaleDocment/CheckCustomerIsRefund', {
        orderId: item.Id
      }).then((resp) => {
        this.isRefund = false
        resp.Data.IsBack
          ? (this.dialogVisible = true)
          : this.$toast({
            position: 'bottom',
            message: resp.Msg
          })
      })
    },
    // 线上退款
    handleOnlineRefund() {
      this.$hys.openLoading()
      this.putAction('/api_aftersale/AfterSaleDocment/CustomerRefundOrder', {
        OrderId: this.dataInfo.Id,
        CustomerApplyRefundType: 1
      }).then((res) => {
        this.$hys.clearLoading()
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
          return
        }
        this.handleClose()
        this.$toast.success('操作成功')
        this.againLoad()
        // this.getLogistics(); //物流
      })
    },
    // 物流包裹切换点击监听
    onChangeLogistics(e) {
      // 根据选中包裹的ID，匹配数据集合，渲染对应物流数据
      this.logisticsData.forEach((l) => {
        if (e.target.value === l.LogisticsWaybillNo) {
          this.changeData = l.LogisticsDocmentTrail
        }
      })
    },
    // 物流信息
    async getLogistics() {
      this.$hys.openLoading()
      const res = await this.postAction(
        '/api_logistics/LogisticsDocment/GetLogisticsDocmentByOrderIds?businessDocmentType=1',
        [this.OrderId]
      )
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data) {
        if (!res.Data.length) return
        const arr = []
        res.Data.forEach((item) => {
          if (item.BusinessDocmentType === 1) {
            // 订单物流
            if (item.LogisticsDocmentState === 2) {
              item.stateName = '运输中'
            } else if (item.LogisticsDocmentState === 3) {
              item.stateName = '运输中'
            } else if (item.LogisticsDocmentState === 4) {
              item.stateName = '部分签收'
            } else if (item.LogisticsDocmentState === 5) {
              item.stateName = '已签收'
            } else {
              item.stateName = '待出库'
            }
            arr.push(item)
          }
        })
        this.logisticsData = arr
        if (this.logisticsData.length > 0) {
          // 默认设置展示第一个包裹物流信息
          this.changeVal = arr[0].LogisticsWaybillNo
          this.changeData = arr[0].LogisticsDocmentTrail
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    getProductsCount() {
      let Count = 0
      this.dataInfo.ProductList.map((item) => {
        Count = Number(item.Count + Count)
      })
      return Count
    },
    getProductPropertie(item, Abbreviation) {
      if (!item.ProductEntity) return null
      if (!item.ProductEntity.CommodityListProperties) return null
      const lst = item.ProductEntity.CommodityListProperties.filter(
        (w) => w.Abbreviation == Abbreviation
      )
      if (!lst) return null
      if (lst.length == 0) return null
      return lst[0]
    },
    // 获取订单详情
    async getOrderLists() {
      this.$hys.openLoading()
      const res = await this.postAction('/api_order/Orders/QueryOrderSkus', {
        OrderId: this.OrderId,
        GoodsIds: []
      })
      if (res.IsSuccess) {
        const { GoodsList, ExchangeList, GiftList } = res.Data
        this.GoodsList = GoodsList
        this.ExchangeList = ExchangeList
        this.GiftList = GiftList
      }
    },
    // 获取订单详情
    async getOrderDetails() {
      this.$hys.openLoading()
      const res = await this.getAction('/api_order/Orders/Get', {
        Id: this.OrderId
      })
      this.loading = false
      this.$hys.clearLoading()

      let statusName = ''
      if (res.IsSuccess && res.Data) {
        switch (res.Data.OrderState) {
          case 1:
            if (
              res.Data.OrderPaymentState == 1 ||
              res.Data.OrderPaymentState == 2 ||
              res.Data.OrderPaymentState == 7
            ) {
              statusName = '待付款'
              this.orderStepActive = 1
            } else if (res.Data.OrderLogisticsState) {
              statusName = '待发货'
              this.orderStepActive = 2
            }
            break
          case 3:
            statusName = '已关闭'
            this.orderStepActive = 0
            break
          default:
            break
        }
        if (res.Data.OrderLogisticsState == 3) {
          statusName = '已发货'
          this.orderStepActive = 3
        }
        if (res.Data.OrderLogisticsState == 5) {
          statusName = '已收货'
          this.orderStepActive = 4
        }
        this.dataInfo = { ...res.Data, statusName }
        if (
          res.Data.OrderLogisticsState == 3 ||
          res.Data.OrderLogisticsState == 5
        ) { this.getLogistics() } // 物流
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    async getOrderPayDetails() {
      this.$hys.openLoading()
      const res = await this.getAction(
        'api_pay/ExpenseApplications/GetOrderPayList',
        {
          // orderId: this.$route.query.id
          orderId: this.OrderId
        }
      )
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data) {
        this.dataPayInfo = res.Data.list
        this.bankInfo = res.Data.CompanyBankAccountInfo
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 申请开票
    goApplyInvoice(item) {
      this.iApplyInvoice = true
      // this.$refs.iApplyInvoice.goApplyInvoice(item);
      this.$refs.iApplyInvoice.setApplyInvoiceId(item)
    },
    // 查看发票
    showInvoice() {
      this.$refs.lookinvoiceinfo.handleShow({ Id: this.OrderId })
    },
    // 取消开票
    handleCancelInvoice() {
      this.iApplyInvoice = false
    },
    // 确认开票
    handleConfirmInvoice() {
      this.iApplyInvoice = false
      this.getOrderDetails()
      this.getOrderPayDetails()
      this.getLogistics() // 物流
    },
    // 查看发票
    handleLookInvoice(item) {
      this.$hys.openLoading()
      this._go('lookInvoiceInfo', { item: item }, null, false)
      this.$hys.clearLoading()
    },
    // 查看物流
    handleViewLogistics(id) {
      this.$hys.openLoading()
      this._go('ViewLogistics', { id: id }, null, false)
      this.$hys.clearLoading()
    },
    // 再次购买
    async handleRepurchase(item) {
      const ProductList = []
      this.submitingRepurchase = true
      this.$hys.openLoading()
      const glst = []
      item.ProductList.forEach((itm) => {
        if (!itm.IsGift) {
          ProductList.push(itm)
          glst.push({ Id: itm.ProductSKUId, Count: itm.Count })
        }
      })
      const res = await this.getAction('/api_order/ShoppingCarts/OrderBuyAgain', {
        orderId: item.Id
      })
      this.$hys.clearLoading()
      if (!res.IsSuccess || !res.Data) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }

      // OrderInfo.CommodityAmountSum + OrderInfo.FreebiesAmountSum
      this.$router.push({ name: LinkTypeCode.BuyCar })
    },
    // 确认收货
    handleConfirmGoods(item) {
      this.dialogMsg = '是否确认收货？'
      this.$refs.iDialogref.iShow(item, 'receipt')
    },
    // 取消订单
    cancelOrder(item) {
      this.$refs.cancelorder.handleShow(item)
      // this.dialogMsg = '是否取消订单？';
      // this.$refs.iDialogref.iShow(item, 'order');
    },
    // 申请退款
    cancelMoney(item) {
      this.dialogMsg = '申请退款'
      this.$refs.iDialogref.iShow(item, 'cancelMoney')
    },
    confirmDialog(data, type) {
      // 申请退款  取消订单
      if (type == 'order' || type == 'cancelMoney') {
        this.$hys.openLoading()
        const res = this.postAction('/api_order/Orders/CancelOrderV2', {
          OrderId: data.Id,
          OrderNo: data.OrderNo
        }).then((res) => {
          this.$hys.clearLoading()
          if (!res.IsSuccess) {
            this.$toast({ position: 'bottom', message: res.Msg })
            return
          }
          this.$toast.success('取消成功')
          this.againLoad()
        })
        return
      }
      if (type == 'receipt') {
        this.$hys.openLoading()
        const res = this.putAction(
          '/api_order/Orders/ConfirmOrder?orderId=' + data.Id
        ).then((res) => {
          this.$hys.clearLoading()
          if (!res.IsSuccess) {
            this.$toast({ position: 'bottom', message: res.Msg })
            return
          }
          this.$toast.success('收货成功')
          this.againLoad()
        })
        return
      }
    },
    againLoad() {
      this.getOrderDetails()
      this.getOrderPayDetails()
      this.getLogistics() // 物流
    },
    // 付款
    async onPay(item) {
      if (
        this.dataPayInfo &&
        this.dataPayInfo.find(
          (w) => w.PayType == '银行转账' && w.EnumExpenseApplicationState == 1
        )
      ) {
        this.showBank = true
        return
      }

      // 判断商品中是否包含已下架或者已失效商品
      let IsPutaway = true

      this.dataInfo.ProductList.forEach((item) => {
        if (!item.ProductEntity.IsPutaway) {
          IsPutaway = false
        }
      })

      if (!IsPutaway) {
        this.$toast({
          position: 'bottom',
          message: '订单中存在已下架或已失效商品,请重新下单'
        })
        return
      }
      this.$hys.openLoading()
      const payInfo = await this.getAction(
        '/api_pay/ExpenseApplications/GetOrderPayInfo',
        {
          id: item.Id,
          no: item.OrderNo
        }
      )
      this.$hys.clearLoading()
      if (payInfo && payInfo.IsSuccess) {
        const param = {
          OrderId: item.Id,
          OrderNo: item.OrderNo,
          PayMoney:
            Number(item.TotalAmountPaidActual - item.TotalAmountPaid) == 0
              ? item.TotalAmountPaidActual
              : Number(item.TotalAmountPaidActual - item.TotalAmountPaid),
          PayInfo: payInfo.Data
        }
        this.$router.push({
          name: LinkTypeCode.SelectPay,
          params: param
        })
      } else {
        this.$router.push({
          name: LinkTypeCode.SelectPay,
          params: {}
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/styles/orderDetails.less');

.ellips-text {
  overflow: hidden;
  width: 80px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

s.origin-price {
  padding-left: 5px;
  font-size: 12px;
  color: #858B9C;
}

.order-details-box {
  padding-bottom: 50px;
  width: 100%;

  .leftbtn {
    min-width: 300px;
  }
}

.orderStatus {
  position: relative;
  border: 1px solid rgba(232, 232, 232, 1);
  border-radius: 2px;
  background: #FFFFFF;
  box-sizing: border-box;

  .btns {
    button {
      margin-right: 20px;
      border-radius: 2px;
      width: 100px;
      height: 34px;

      &:last-child {
        // margin-right: 0;
      }
    }

    .bFF3939 {
      border: 1px solid #FF3939;
      color: #FF3939;
    }

    .refundBtn {
      color: #FFFFFF;
      background: #D1D1D1;
    }

    .b0F6EE9 {
      border: 1px solid #0F6EE9;
      color: #0F6EE9;
    }

    .bE5E5E5 {
      border: 1px solid #E5E5E5;
      color: #777777;
      background: rgba(250, 250, 250, 1);
    }
  }

  .rightimg {
    padding-top: 60px;
    padding-bottom: 68px;
    padding-left: 56px;

    /deep/ .van-step {
      position: relative;
      margin-right: 72px;
      width: 74px;

      &:last-child {
        margin-right: 0;

        /deep/ .van-step__line {
          display: none;
        }
      }

      .van-icon {
        margin-bottom: 32px;
      }

      h3 {
        margin: 0;
      }

      p {
        margin: 4px 0 0;
      }
    }

    /deep/ .van-steps--horizontal {
      padding: 0;
    }

    /deep/ .van-step--horizontal .van-step__title {
      margin-left: 0;
      transform: none;
    }

    /deep/ .van-step__circle-container {
      display: none;
    }

    /deep/ .van-step__line {
      position: absolute;
      top: 16px;
      left: 64px;
      border-radius: 1px;
      width: 89px;
      height: 1px;
      background:
        linear-gradient(
          239deg,
          rgba(79, 155, 253, 1) 0%,
          rgba(54, 139, 248, 1) 100%
        );
    }
  }
}

.w86 {
  width: 86px;
}

.w120 {
  width: 120px;
}

.w208 {
  width: 208px;
}

.product-table {
  width: 100%;

  tr {
    > th {
      height: 50px;
      font-size: 14px;
      color: #999999;
      background: rgba(245, 245, 245, 1);

      &:first-child {
        color: #222222;
      }
    }

    > td {
      border-bottom: 1px solid #E0E0E0;
      padding: 30px 20px;
      text-align: left;
    }

    &:last-child {
      > td {
        border-bottom: none;
      }
    }
  }

  /deep/ .zengsong.van-image {
    position: relative;

    &::after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      height: 24px;
      font-size: 10px;
      text-align: center;
      color: #FFFFFF;
      background: rgba(255, 57, 57, .6);
      content: '赠品';
      line-height: 24px;
    }
  }
}

.logistics-box {
  /deep/ .van-steps {
    padding-left: 165px;

    /deep/ .van-step {
      /deep/ .van-step__title {
        div {
          &:last-child {
            position: absolute;
            top: 10px;
            left: -182px;
          }
        }
      }
    }
  }
}

/deep/ .van-hairline--bottom::after {
  border-bottom-width: 0;
}

/deep/ .van-grid-item {
  flex-basis: 1.4rem !important;
  height: 1.4rem;

  .van-grid-item__content {
    padding: 5px;
  }
}

.width3 {
  width: .3rem;
  height: .38rem;
}

.width36 {
  width: .36rem;
  height: .3rem;
}

.lookListBtn {
  margin-left: .6rem;
  border: 1px solid rgba(15, 110, 234, 1);
  border-radius: .5rem;
  width: 1.5rem;
  height: .46rem;
  font-size: .22rem;
  font-weight: 400;
  text-align: center;
  color: rgba(15, 110, 234, 1);
  line-height: .46rem;
}

.payBtn {
  border: 1px solid rgba(255, 57, 57, 1);
  border-radius: .5rem;
  width: 1.62rem;
  height: .59rem;
  font-size: .24rem;
  color: #FFFFFF;
  background:
    linear-gradient(
      183deg,
      rgba(255, 126, 83, 1) 0%,
      rgba(255, 57, 57, 1) 100%
    );
}

.plainBtn {
  border: 1px solid rgba(255, 57, 57, 1);
  border-radius: .5rem;
  width: 1.62rem;
  height: .59rem;
  font-size: .24rem;
  color: #FF3939;
}

.plainBtnBlack {
  border: 1px solid rgba(34, 34, 34, 1);
  border-radius: .5rem;
  width: 1.62rem;
  height: .59rem;
  font-size: .24rem;
  color: #222222;
}

.fzBtn {
  display: inline-block;
  border-radius: .19rem;
  width: .86rem;
  height: .37rem;
  font-size: .22rem;
  font-weight: 400;
  text-align: center;
  color: rgba(15, 110, 234, 1);
  background: rgba(235, 244, 255, 1);
  line-height: .37rem;
}

.fTag {
  border-radius: .04rem;
  background:
    linear-gradient(
      348deg,
      rgba(246, 85, 28, 1) 0%,
      rgba(255, 134, 57, 1) 100%
    );
}

.pl26 {
  padding-left: .56rem;
}

.bank-info {
  box-sizing: border-box;
  padding: .4rem;
  font-size: .24rem;
}

.bank-itm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .2rem;
  flex-direction: row;
}

.tindent36 {
  text-indent: 36px;
}

.borderff3939 {
  border: 1px solid rgb(255, 57, 57);
}

.wrapper {
  margin: 5% auto;
  max-width: 1200px;
}

.wrapper.logistics {
  width: 960px;
}

.customer-title {
  margin-bottom: 20px;
}
</style>
<style lang="less">
.apply-wrap-box {
  text-align: left;

  .el-dialog__body {
    // padding-top: 0px;
    text-align: center;
  }

  .el-dialog__footer {
    text-align: center;
  }

  h6 {
    font-size: 16px;
    color: #222222;
  }
}

.card {
  margin: 0 auto;
  margin-top: 30px;
  border: 1px solid rgba(232, 232, 232, 1);
  width: 928px;
  font-size: 14px;
  font-weight: 600;
  color: #222222;

  a {
    color: #0F6EEA;
  }

  &-t {
    padding-left: 20px;
    height: 50px;
    font-size: 16px;
    text-align: left;
    background-color: #F5F5F5;
    line-height: 50px;
    box-sizing: border-box;

    span {
      font-size: 16px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }

  &-i {
    padding-top: 20px;
    padding-left: 20px;
    box-sizing: border-box;

    .img {
      margin: 10px 0 30px;
      width: 180px;
      height: 60px;
      cursor: pointer;
    }

    .revc-info-itm {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 10px;
      font-weight: 400;

      .left {
        width: 100px;
        text-align: left;
        color: #999999;
      }

      .right {
        margin-left: 10px;

        span {
          margin-right: 8px;
        }
      }

      .el-icon-arrow-right {
        margin-right: 10px;
        font-size: 20px;
      }

      .tips {
        position: absolute;
        top: 0;
        right: 5px;
        font-size: 12px;
        color: rgba(15, 110, 234, 1);
        line-height: 20px;

        > a:hover {
          color: #0F6EEA;
        }

        > a:link {
          color: #0F6EEA;
        }

        > a:visited {
          color: #0F6EEA;
        }
      }
    }

    .pro-lst {
      position: relative;
      display: flex;
      border-bottom: 2px rgba(224, 224, 224, .3) solid;
      padding: 30px 0 30px 20px;
      text-align: left;
      box-sizing: border-box;

      .img-overlay,
      span {
        position: absolute;
        bottom: 30px;
        left: 20px;
        width: 100px;
        height: 25px;
        font-size: 14px;
        text-align: center;
        color: #FFFFFF;
        line-height: 25px;
      }

      .img-overlay {
        background-color: #FF3939;
        opacity: .6;
      }

      .pro-content {
        padding-left: 25px;
        width: 355px;

        .gname {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #222222;
        }

        .gsize {
          margin-top: 10px;
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #777777;
        }

        .name-title {
          width: 190px;
          flex: 1;
        }
      }

      .pro-col {
        width: 175px;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #222222;
      }

      .pro-total {
        font-weight: 600;
        color: #FF3939;
      }

      &:last-child {
        border: none;
      }
    }

    .copun {
      border: 1px solid rgba(232, 232, 232, 1);
      width: 180px;
      height: 60px;
      font-size: 16px;
      text-align: center;
      color: rgba(153, 153, 153, 1);
      box-sizing: border-box;
      line-height: 60px;
      cursor: pointer;
    }

    .copun-sed {
      position: relative;
      height: 60px;
      text-align: center;
      color: #FF3939;
      background-size: 100%;
      line-height: 60px;

      > div {
        float: left;
        box-sizing: border-box;
      }

      .left {
        border: 1px #FF3939 solid;
        border-right: none;
        width: 140px;
        height: 60px;
        background-color: #FFE4E5;
      }

      .middle {
        width: 16px;
        height: 60px;
        background-image: url(../../assets/buycar/bg3.png);
      }

      .right {
        border: 1px #FF3939 solid;
        border-left: none;
        width: 71px;
        height: 60px;
        cursor: pointer;
      }
    }

    .copun-tip {
      margin-top: 20px;
      margin-bottom: 30px;
      font-size: 16px;
      color: #222222;
    }

    .order-price-itm {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;

      .left {
        width: 100px;
        text-align: right;
        color: #999999;
      }

      .right {
        margin-left: 10px;
        padding-right: 20px;
        width: 300px;
        text-align: right;
        color: #FF3939;

        span {
          margin-right: 8px;
        }
      }
    }

    .coupons {
      display: flex;
      align-items: center;
      margin-top: 25px;
      min-height: 50px;
      background: rgba(255, 246, 216, 1);
      flex-wrap: wrap;

      .coupons-tag {
        margin-left: 20px;
        border-radius: 2px;
        padding: 2px 7px;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        background:
          linear-gradient(
            166deg,
            rgba(255, 134, 57, 1) 0%,
            rgba(255, 71, 71, 1) 100%
          );
      }

      .coupons-content {
        margin-left: 24px;
        font-size: 16px;
        color: #D3691F;
      }
    }

    .submit {
      padding: 25px 20px;
      background-color: #F8F8F8;

      .money,
      .address {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        > div {
          font-weight: normal;

          > span {
            margin-left: 10px;

            &:first-child {
              margin-left: 0;
            }
          }

          &:first-child {
            width: 100px;
            text-align: right;
            color: #999999;
          }

          &:last-child {
            width: 300px;
            font-size: 26px;
            text-align: right;
            color: #FF3939;
          }
        }
      }

      .address {
        margin-top: 10px;

        > div {
          margin-left: 30px;
          font-size: 14px;
          text-align: right;
          color: #999999;

          &:first-child {
            margin-left: 30px;
            width: auto;
            font-size: 14px;
            color: #999999;
          }

          &:last-child {
            margin-left: 30px;
            width: auto;
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }

  &-f {
    margin-top: 30px;
    height: 3px;
    background-image: url(../../assets/buycar/bg1.png);
  }
}

.pt30i.pb30i.van-cell.van-cell--center.van-cell--borderless {
  background: #F5F5F5;
}

.is-sys-choose-tips {
  position: absolute;
  top: 3px;
  display: inline-block;

  /* right: 0; */
  margin-left: 4px;
  border: 1px solid;
  border-radius: 4px;
  width: 56px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  text-align: center;
  color: #FF3939;
  font-style: normal;
}

.van-tag--plain::before {
  border: unset !important;
}
</style>
